import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.42848 4.37166C9.63359 3.85887 9.38417 3.2769 8.87139 3.07179C8.35861 2.86668 7.77664 3.11609 7.57152 3.62888L5.82307 8H4.19784C4.18677 8 4.17573 8.00009 4.16471 8.00027H4C3.83872 8.00027 3.68635 8.03845 3.55145 8.10627C2.64512 8.41497 2.04755 9.35374 2.2301 10.3578L3.71717 18.5367C3.97653 19.9631 5.21892 21 6.66878 21H17.3305C18.7803 21 20.0227 19.9631 20.2821 18.5367L21.7692 10.3578C21.9516 9.35458 21.3552 8.41656 20.4501 8.10705C20.3148 8.03874 20.1619 8.00027 20 8.00027H19.8346C19.8235 8.00009 19.8125 8 19.8014 8H18.1769L16.4285 3.62888C16.2234 3.11609 15.6414 2.86668 15.1286 3.07179C14.6158 3.2769 14.3664 3.85887 14.5715 4.37166L16.0229 8H7.97714L9.42848 4.37166Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }